import { isAllItemMode, setClearSelectedTolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { tableShowAllItems } from '@/core/support_gui_components/table/table'

export function SelectedItemsManager () {

	var TABLE_SELECTOR = '#table'
	var SELECTED_COUNT_SELECTOR = '#table_toolbar_selected_count'

	var selectionsMap = {}
	var startIndex
	var endIndex

	this.beforeSelectedModePage = 0
	this.beforeSelectedModeItemsPerPage = 0

	this.beforeSelectedModeSortAsc = null
	this.beforeSelectedModeSortAttr = null

	this.getSelectionsConfig = function () {
		return {
			selections: selectionsMap,
			page: this.beforeSelectedModePage,
			itemsPerPage: this.beforeSelectedModeItemsPerPage,
			sortAsc: this.beforeSelectedModeSortAsc,
			sortAttr: this.beforeSelectedModeSortAttr
		}
	}

	this.setSelectionsConfig = function (config) {
		selectionsMap = config.selections
		this.beforeSelectedModePage = config.page
		this.beforeSelectedModeItemsPerPage = config.itemsPerPage
		this.beforeSelectedModeSortAsc = config.sortAsc
		this.beforeSelectedModeSortAttr = config.sortAttr
	}

	this.getSelectedCount = function () {
		return _.size(selectionsMap)
	}

	this.updateIndexesForSelected = function (table) {
		if (table.selectedItemsMode) {
			var ind = 0
			_.each(selectionsMap, function (val, key) {
				selectionsMap[key] = ind++
			})
		} else {
			_.each(selectionsMap, function (val, key) {
				var keyInRequiredFormat = (key.length === 24) ? key : parseInt(key)
				selectionsMap[key] = _.indexOf(table.itemsIDs, keyInRequiredFormat)
			})
		}
	}

	this.addRowMarkById = function (itemId, index) {
		selectionsMap[itemId] = index
	}

	this.deleteRowMarkById = function (itemId) {
		delete selectionsMap[itemId]
	}

	this.addRowMark = function (table, itemId) {
		this.addRowMarkById(itemId, table.dataIndex + (table.currentPage - 1) * table.itemsPerPage)
		updateSelectedCount()

		window.ClientSessionManager.saveTableState(table)
	}

	this.deleteRowMark = function (itemId) {
		this.deleteRowMarkById(itemId)
		updateSelectedCount()

		window.ClientSessionManager.saveTableState(table)
	}

	function updateIndexes (pageNumber, itemsPerPage, itemsCount) {
		startIndex = pageNumber * itemsPerPage - itemsPerPage
		endIndex = (pageNumber * itemsPerPage) > itemsCount ? itemsCount - 1 :
			pageNumber * itemsPerPage - 1
	}

	this.markRows = function (table) {
		updateIndexes(table.currentPage, table.itemsPerPage, table.getItemsCount())
		var indexes = _.filter(selectionsMap, function (val) {
			return val >= startIndex && val <= endIndex
		})
		$(TABLE_SELECTOR).bootstrapTable('checkGroup', {
			indexes: _.map(indexes, function (val) {
				return val - startIndex
			}),
			checked: true
		})
		updateSelectedCount()
	}

	this.addPageMark = function (table) {
		updateIndexes(table.currentPage, table.itemsPerPage, table.getItemsCount())
		for (var i = startIndex; i <= endIndex; ++i) {
			this.addRowMarkById(table.data[i - startIndex].id, i)
		}
		updateSelectedCount()
	}

	this.deletePageMark = function (table) {
		updateIndexes(table.currentPage, table.itemsPerPage, table.getItemsCount())
		for (var i = startIndex; i <= endIndex; ++i) {
			this.deleteRowMarkById(table.data[i - startIndex].id)
		}
		updateSelectedCount()
	}

	this.getSelections = function () {
		return _.keys(selectionsMap)
	}

	this.clearSelections = function (table) {
		selectionsMap = {}
		updateSelectedCount()
		if (isAllItemMode()) {
			tableShowAllItems(null, table)
		} else {
			table.initTable()
		}

		window.ClientSessionManager.saveTableState(table)
	}

	function updateSelectedCount () {
		$(SELECTED_COUNT_SELECTOR).text(_.size(selectionsMap) + '')
		setClearSelectedTolbarMode();
	}
}
